import { formatText } from 'core/i18n';

export const getMessageErrors = isRequired => ({
    ...(isRequired && { required: formatText('validation-fieldRequired') }),

    valid: formatText('validation-syntaxErrorDocument'),
});
